module.exports = __webpack_public_path__ + "img/139.cb87758d.jpg";